import * as Sentry from '@sentry/browser';
import { BalanceManagerApiService } from '@/services/api';
import type { BankSlipType } from './types';

type useOverdueBankSlipType = {
  getOverdueBankSlips: (contractId: string) => Promise<BankSlipType[]>;
};

function useOverdueBankSlip(): useOverdueBankSlipType {
  const { api } = BalanceManagerApiService();

  async function getOverdueBankSlips(
    contractId: string,
  ): Promise<BankSlipType[]> {
    try {
      const { data } = await api.get<BankSlipType[]>(
        `/external/v1/contract/${contractId}/bank_slips/overdue`,
      );

      return data;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          message:
            "Attempt to retrieve overdue bank slips ended in failure, possibly due to the absence of the contract's id",
        },
      });
    }

    return [];
  }

  return { getOverdueBankSlips };
}

export default useOverdueBankSlip;
